import React from "react";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import DiscountIcon from "@mui/icons-material/Discount";
import PaidIcon from "@mui/icons-material/Paid";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";

const cards = [
  { key: "totalSum", label: "Total", icon: AccountBalanceWalletIcon, bg: "bg-amber-100", text: "text-amber-700", iconBg: "bg-amber-500" },
  { key: "discountSum", label: "Discount", icon: DiscountIcon, bg: "bg-orange-100", text: "text-orange-700", iconBg: "bg-orange-500" },
  { key: "paid", label: "Paid", icon: PaidIcon, bg: "bg-sky-100", text: "text-sky-700", iconBg: "bg-sky-500", computed: true },
  { key: "cardSum", label: "Card", icon: CreditCardIcon, bg: "bg-indigo-100", text: "text-indigo-700", iconBg: "bg-indigo-500" },
  { key: "bankTransferSum", label: "Transfer", icon: AccountBalanceIcon, bg: "bg-emerald-100", text: "text-emerald-700", iconBg: "bg-emerald-500" },
  { key: "cashSum", label: "Cash", icon: LocalAtmIcon, bg: "bg-red-100", text: "text-red-700", iconBg: "bg-red-500" },
];

function PaymentCount({ count }: any) {
  const getValue = (card: any) => {
    if (card.computed) {
      return (count?.bankTransferSum ?? 0) + (count?.cashSum ?? 0) + (count?.cardSum ?? 0);
    }
    return count?.[card.key] ?? 0;
  };

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2 mb-3">
      {cards.map((card) => (
        <div key={card.key} className={`${card.bg} rounded-lg p-3 flex flex-col items-center justify-center`}>
          <div className={`w-8 h-8 ${card.iconBg} rounded-md flex items-center justify-center mb-1.5`}>
            <card.icon className="text-white" sx={{ fontSize: 16 }} />
          </div>
          <h3 className={`text-lg font-bold ${card.text}`}>{getValue(card)}</h3>
          <span className={`text-[10px] font-medium ${card.text} uppercase tracking-wide`}>{card.label}</span>
        </div>
      ))}
    </div>
  );
}

export default PaymentCount;
